var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 110,
    viewBox: "0 0 128 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram_2019_Logo 2",
    clipPath: "url(#clip0_192400_52284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.0266 128.053C99.3876 128.053 128.053 99.3876 128.053 64.0266C128.053 28.6657 99.3876 0 64.0266 0C28.6657 0 0 28.6657 0 64.0266C0 99.3876 28.6657 128.053 64.0266 128.053Z",
    fill: "#E8EDF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9438 63.3371C47.6027 55.2338 60.0242 49.8494 66.2616 47.2372C84.0142 39.8269 87.746 38.5475 90.145 38.4941C90.6781 38.4941 91.8509 38.6008 92.6506 39.2405C93.2903 39.7736 93.4503 40.4667 93.5569 40.9998C93.6635 41.5329 93.7701 42.6524 93.6635 43.5054C92.7039 53.6345 88.5456 78.2109 86.4132 89.5129C85.5069 94.3109 83.7476 95.9102 82.0417 96.0702C78.3099 96.39 75.4844 93.6178 71.9126 91.2722C66.2616 87.5937 63.1162 85.3013 57.6252 81.6761C51.2812 77.5179 55.3861 75.2255 59.0113 71.4937C59.9709 70.5341 76.3374 55.607 76.6573 54.2742C76.7106 54.1143 76.7106 53.4746 76.3374 53.1547C75.9642 52.8348 75.4311 52.9415 75.0046 53.0481C74.4182 53.1547 65.4619 59.1255 48.0292 70.9073C45.4703 72.6666 43.1779 73.5196 41.0987 73.4662C38.8064 73.4129 34.4349 72.1868 31.1296 71.1205C27.1312 69.8411 23.9326 69.148 24.1991 66.909C24.3591 65.7361 25.9584 64.5633 28.9438 63.3371Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192400_52284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram_logo.e8f31e83a1a45e0b18d064900a63685e.svg";
export { ForwardRef as ReactComponent };